import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from './page-layout/page-layout.component';
import { NgZorroAntdModule } from './ng-zorro-antd.module';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { EmptyOrganisationComponent } from './components/empty-organisation/empty-organisation.component';
import { MobileSidebarComponent } from './components/mobile-sidebar/mobile-sidebar.component';
import { ConfirmSwitchTabPopupComponent } from './popup/confirm-switch-tab-popup/confirm-switch-tab-popup.component';
import { TimePopupComponentComponent } from './components/time-popup-component/time-popup-component.component';
import { AddMorePopupComponent } from './popup/add-more-popup/add-more-popup.component';
import { UploadIconPopupComponent } from './popup/upload-icon-popup/upload-icon-popup.component';
import { CreateNewEntityComponent } from './components/create-new-entity/create-new-entity.component';
import { ConfirmDeletePopupComponent } from './popup/confirm-delete-popup/confirm-delete-popup.component';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { CreateFieldComponent } from './components/create-field/create-field.component';
import { AddNewColumnComponent } from './components/add-new-column/add-new-column.component';
import { DropdownComponent } from './components/add-new-column/popup/dropdown/dropdown.component';
import { StatusPopupComponent } from './components/add-new-column/popup/status-popup/status-popup.component';
import { TagPopupComponent } from './components/add-new-column/popup/tag-popup/tag-popup.component';
import { ShowFieldPopupComponent } from './popup/show-field-popup/show-field-popup.component';
import { CommonFilterComponent } from './components/common-filter/common-filter.component';
import { JsonTextAreaComponent } from './components/json-text-area/json-text-area.component';
import { SingleFilterComponent } from './components/single-filter/single-filter.component';
import { RecordVisibilityFilterComponent } from './components/record-visibility-filter/record-visibility-filter.component';
import { HeaderNavBarComponent } from './components/header-nav-bar/header-nav-bar.component';
import { ManageOrgHeaderOptionComponent } from './components/manage-org-header-option/manage-org-header-option.component';
import { HeaderMenuComponent } from './components/header-menu/header-menu.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddNewTabComponent } from './components/add-new-column/popup/add-new-tab/add-new-tab.component';
import { ParentFilterComponent } from '@processo/modules/dashboard/components/parent-filter/parent-filter.component';
import { RecurrencePopupComponent } from './popup/recurrence-popup/recurrence-popup.component';
@NgModule({
  declarations: [
    PageLayoutComponent,
    HeaderComponent,
    SidebarComponent,
    MobileSidebarComponent,
    ConfirmSwitchTabPopupComponent,
    TimePopupComponentComponent,
    AddMorePopupComponent,
    UploadIconPopupComponent,
    CreateNewEntityComponent,
    ConfirmDeletePopupComponent,
    CreateFieldComponent,
    AddNewColumnComponent,
    DropdownComponent,
    StatusPopupComponent,
    TagPopupComponent,
    ShowFieldPopupComponent,
    CommonFilterComponent,
    JsonTextAreaComponent,
    SingleFilterComponent,
    RecordVisibilityFilterComponent,
    HeaderNavBarComponent,
    ManageOrgHeaderOptionComponent,
    HeaderMenuComponent,
    AddNewTabComponent,
    RecurrencePopupComponent,
  ],
  imports: [CommonModule, RouterModule, NgZorroAntdModule,PickerModule, FormsModule, ReactiveFormsModule],
  exports: [
    PageLayoutComponent,
    HeaderComponent,
    SidebarComponent,
    MobileSidebarComponent,
    ConfirmSwitchTabPopupComponent,
    CreateNewEntityComponent,
    ConfirmDeletePopupComponent, 
    CreateFieldComponent,
    AddNewColumnComponent,
    ShowFieldPopupComponent,
    CommonFilterComponent,
    JsonTextAreaComponent,
    SingleFilterComponent,
    RecordVisibilityFilterComponent,
    HeaderNavBarComponent,
    ManageOrgHeaderOptionComponent,
    HeaderMenuComponent,
    AddNewTabComponent,
    AddNewTabComponent
  ],
})
export class SharedModule {}
